export const sectionReducer = (state = null, action) => {
  switch (action.type) {
    case "UPDATE_SECTION":
      return action.section;
    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/core/section/reducer.js
 **/